import enLocale from "@lib/services/localization/locales/en_US.json";
import trLocale from "@lib/services/localization/locales/tr_TR.json";

const config = {
  languages: ["en", "tr"],
  defaultLanguage: "en",
  locales: {
    en: enLocale,
    tr: trLocale,
  },
};

type I18nProps = {
  locale: string;
  id: string;
  params?: Record<string, string | number | null>;
};

export const i18n = (props: I18nProps) => {
  const { id, params } = props;
  let locale = props.locale;

  if (!config.languages.includes(locale)) {
    locale = config.defaultLanguage;
  }

  const langFile = config.locales[locale];
  const message = langFile?.[id] || id;

  if (!params) return message;

  return message.replace(/\{([^{}]+)\}/g, (match, p1) => params[p1] || match);
};
